import { Stack } from "@mui/material";
import { useIsDesktop } from '@repo/ui';
import { type FC, type PropsWithChildren } from "react";

export const LoginLayout: FC<PropsWithChildren & { image: React.JSX.Element }> = ({ children, image }) => {
	const isD = useIsDesktop();

	return (
		<Stack
			sx={{
				position: "relative",
				flexGrow: 1,
				alignItems: { md: "flex-end" },
			}}
		>
			{isD && image}
			<Stack
				spacing={5}
				sx={{
					flexGrow: 1,
					width: { md: "48%" },
					overflowY: "hidden",
					mx: { md: "-8px", xs: 0 },
					pb: 3,
					px: { md: 3, xs: 4 },
				}}
			>
				{children}
			</Stack>
		</Stack>
	);
};


